import React from 'react';

// containers
import Page from '../../layout/containers/Page/Page';
import OrdersContainer from '../../containers/OrdersContainer/OrdersContainer';

// Constants
import page from './page';

const OrdersPage = () => {
  return (
    <Page page={page}>
      <OrdersContainer />
    </Page>
  );
};

export default OrdersPage;
